<template>
  <!-- <div>宣讲会</div> -->
  <div class="container" ref="container">
    <div class="bg-f7">
      <div class="depart flex-between">
        <div class="video-box color-333">
          <p class="font-20 font-bold">数字科技，等你来造！</p>
          <p>
            联蔚数科2024校园招聘空中宣讲会
            {{ playDepart.name ? "——" + playDepart.name : "" }}
          </p>
          <div
            :class="[playVideo ? 'play-video' : 'pause-video']"
            :style="{ backgroundImage: 'url(' + playDepart.background + ')' }"
          >
            <span class="tag">09-22 17:00 敬请期待</span>
            <video
              v-if="playVideo"
              class="video"
              id="media"
              :src="playDepart.link"
              controls="controls"
              preload="meta"
              @playing="getVideo"
            ></video>
          </div>
        </div>
        <div class="depart-item bg-fff">
          <p class="color-333 font-bold">部门专场</p>
          <div
            v-for="(item, index) in departList"
            :key="index"
            @click="getVideoLink(index)"
            class="item flex-between"
          >
            <div :class="[item.link == playDepart.link ? 'color-primary' : '']">
              <p class="color-333 font-bold">{{ item.name }}</p>
              <p class="color-666">{{ item.info }}</p>
            </div>
            <el-button size="mini" plain @click="goPosition(item.code, 'new')"
              >查看岗位</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="bg-fff">
      <div class="line"></div>
      <el-tabs v-model="activeName" class="title-tabs">
        <el-tab-pane label="招聘流程" name="first">
          <h3>招聘流程</h3>
          <div class="flow">
            <div class="item" v-for="(item, index) in flowList" :key="index">
              <el-image
                style="width: 80px; height: 80px"
                :src="item.icon"
              ></el-image>
              <p class="font-20 color-333 font-bold">{{ item.name }}</p>
              <p class="font-14 color-666">{{ item.time }}</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="培养计划" name="second">
          <h3>培养计划</h3>
          <div class="plan-box flex-wrap">
            <div
              v-for="(item, index) in planList"
              :key="index"
              @click="getplanInfo(index)"
              class="plan-item flex"
            >
              <el-image :src="item.image" alt="" />
              <div class="right-info color-333">
                <h4>{{ item.title }}</h4>
                <p class="color-666">（{{ item.type }}）</p>
                <p>{{ item.depart }}</p>
                <p class="color-999">查看详情</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="答疑专区" name="third">
          <h3>联蔚数科2024校园招聘 Q&A</h3>
          <div
            :class="[
              linkFixed ? 'link-fixed' : '',
              'link-container',
              'flex-between',
            ]"
          >
            <div class="link-box" :style="[linkFixed ? 'left:120px' : '']">
              <div
                :class="[item.checked ? 'link-checked' : '', 'link-item']"
                v-for="(item, index) in quizList"
                :key="index"
                @click="jump(index)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="link-content">
              <div class="content" id="link0">
                <div class="box">
                  <h4>关于简历投递</h4>
                  <div class="question">
                    <p>符合怎样条件和专业的人可以进行网申？</p>
                    <p>
                      在 2023 年 9 月至 2024 年 8
                      月期间毕业（中国大陆以毕业证为准，非中国大陆地区以学位证为准），且最高学历毕业后无全职工作经验的学生。
                    </p>
                  </div>
                  <div class="question">
                    <p>简历投递入口在哪里？怎么看申请状态？</p>
                    <p>
                      <a
                        href="https://www.lianwei.com.cn/join-us.html"
                        target="_blank"
                        >联蔚数科校园招聘官网</a
                      >，为本次校园招聘职位的简历投递唯一入口，在电脑及手机上均可进行投递。简历投递后，我们会通过邮件、短信等方式同步笔试及面试安排，请确保投递时填写的手机号码及邮箱正确，hr会第一时间联系并保持沟通同步实时更新进展。
                    </p>
                  </div>
                  <div class="question">
                    <p>招聘流程和时间节点是怎么样的？</p>
                    <p>
                      投递时间：9月 1 日 - 11 月 30 日 <br />
                      面试时间：9 月中旬开始<br />
                      测评时间：9 月下旬开始<br />
                      offer 发放时间：9 月中旬开始
                    </p>
                  </div>
                  <div class="question">
                    <p>招聘工作地点是怎么分布的？</p>
                    <p>上海 / 南京 / 北京 / 广州 / 沈阳</p>
                  </div>
                </div>
              </div>
              <div class="content" id="link1">
                <div class="box">
                  <h4>关于面试</h4>
                  <div class="question">
                    <p>对英文要求高么？</p>
                    <p>根据不同岗位类型对英文有不同的要求</p>
                  </div>
                  <div class="question">
                    <p>人在海外/异地无法现场面试的，可以安排在线面试么？</p>
                    <p>可以线上视频面试</p>
                  </div>
                  <div class="question">
                    <p>面试后多长时间可以收到结果？</p>
                    <p>面试测评后一般一周内</p>
                  </div>
                  <div class="question">
                    <p>测评都测哪些内容？</p>
                    <p>
                      我们会针对应聘者进行以下三个维度的评估测评<br />
                      1、语言能力：理解言语信息并基于言语信息做出推论的能力<br />
                      2、数学能力：快速抓取核心数据信息并利用数学运算，推理等解决问题的能力<br />
                      3、逻辑推理：从事物中快速获取规律并应用规律的能力<br />
                      整个测评共需30分钟
                    </p>
                  </div>
                </div>
              </div>
              <div class="content" id="link2">
                <div class="box">
                  <h4>关于员工福利</h4>
                  <div class="question">
                    <p>
                      联蔚数科是一家怎样的公司？选择加入联蔚数科的理由是什么？
                    </p>
                    <p>
                      联蔚成立于2000年，二十年来一直聚焦数字化变革，致力于为企业的数字化建设助力。集团旗下共有四大业务板块：数字化营销与销售解决方案、数字化运营管理解决方家、云管理服务解决方家．生产与供应链系统解决方家，，基于自身强大的技术背景和丰富行业经验，结合客户洞察，助力不同行业企业应对数字化时代瞬息万变的商业挑战。
                    </p>
                    <p>
                      公司总部位于上海，在南京、北京、广州均设有研发和服务机构，汇聚了千余名专业技术人才，拥有自主研发能力和自主知识产权的产品，为众多国际国内知名品牌提供基于大数据的咨询服务、行业领先的信息化产品和解决方案。
                    </p>
                  </div>
                  <div class="question">
                    <p>
                      联蔚数科有哪些新员工培训计划？在联蔚数科能收获哪些成长？
                    </p>
                    <p>
                      联蔚非常重视每位新员工的培养和体验，在新员工方面投入大量人力和精力。在集团层面，联蔚新员工需要参加入职当天的培训，在线训练营，月度新员工Orientation，帮助新员工快速了解业务，知晓文化价值观，了解联蔚职场。同时，集团层面管理层高度重视新员工培训，每月与新员工面对面沟通交流。在各子品牌/事业部层面，专门为新员工开展了融入计划，帮助新员工迅速掌握工作所需技能，融入团队，开展工作。
                    </p>
                    <p>
                      在联蔚，我们针对不同人群，多方位开展对应的培训，以助力我们的员工发展。在线，我们有学习平台，提供政策/流程、通用技能、专业能力、领导力等方面的在线学习资源。线下，我们根据学员需求，定制学习项目，通过探讨、案例分析、行动学习等多种方式，结合实践，帮助学员深化并应用知识。
                    </p>
                  </div>
                  <div class="question">
                    <p>联蔚数科有哪些员工福利？</p>
                    <p>
                      完善的商业保险制度，守护你的前行<br />

                      五险一金及补充商业保险，给前进路上的你提供最踏实、安心的保障
                    </p>
                    <p>
                      温暖的节日礼品，点亮每一个值得庆祝的日子<br />

                      春节家书礼盒、六一儿童节亲子礼包、入职周年纪念品等，每一个值得庆祝的日子，我们都记在心上
                    </p>
                    <p>
                      丰富多彩员工的工作生活<br />
                      (联蔚女神节/儿童节/年会等）
                    </p>
                  </div>
                  <div class="question">
                    <p>有没有落户政策？</p>
                    <p>入职满一年后符合条件的可办理落户</p>
                  </div>
                  <!-- <div class="question">
                    <p>会提供住宿么？</p>
                    <p>
                      目前不提供住宿，实习期间学校生源非当地的给予住宿津贴50元/天
                    </p>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible.sync="dialogVisible" class="modal-1240">
      <h1>培养计划</h1>
      <div
        class="top-banner"
        :style="{ backgroundImage: 'url(' + planInfo.background + ')' }"
      >
        <div class="info color-333">
          <p>
            <span class="font-30 font-bold">{{ planInfo.title }}</span>
            <span class="font-14 color-666">（{{ planInfo.depart }}）</span>
          </p>
          <p>{{ planInfo.description }}</p>
        </div>
      </div>
      <div class="flex-between color-333">
        <div class="box bg-f7">
          <p class="title">计划介绍</p>
          <div class="plan-con" v-html="planInfo.plandesc"></div>
        </div>
        <div class="box bg-f7">
          <p class="title">覆盖岗位</p>
          <div class="work-con">
            <span v-for="(item, index) in planInfo.workList" :key="index">
              {{ item }}
            </span>
          </div>
          <el-button size="mini" @click="goPosition(planInfo.code, 'new')"
            >查看岗位</el-button
          >
        </div>
      </div>
      <el-image :src="planInfo.image1" alt="" lazy />
      <el-image :src="planInfo.image2" alt="" lazy />
      <el-image :src="planInfo.image3" alt="" lazy />
      <el-image :src="planInfo.image4" alt="" lazy />
      <el-image :src="planInfo.image5" alt="" lazy />
    </el-dialog>
  </div>
</template>

<script>
import util from "./../utils/util";
import myApi from "./../utils/api";

export default {
  data() {
    return {
      activeName: "first",
      marginTop: "", //元素距离顶部距离
      linkFixed: false, //左部导航吸顶
      checkedQuestion: 0,
      isScroll: true,
      playVideo: false, //视频能否播放
      playDepart: {
        background: require("./../assets/image/banner-dt.png"),
      }, //在播的部门
      endTime: new Date("2021/09/22 17:00:00"),
      timer: null, //倒计时
      dialogVisible: false, // 弹窗
      planInfo: {}, //计划详情
      departList: [
        {
          name: "【联蔚信息-EeS】专场",
          code: "EeS",
          info: "科技赋能电子商务系统解决方案",
          background: require("./../assets/image/banner-ees.png"),
          link: "https://lianwei.com.cn/file/2024EeS.mp4",
        },
        {
          name: "【联蔚信息-DMCS】专场",
          code: "DMCS",
          info: "科技赋能数字营销系统解决方案",
          background: require("./../assets/image/banner-dmcs.png"),
          link: "https://lianwei.com.cn/file/2024DMCS.mp4",
        },
        {
          name: "【联蔚盘云】专场",
          code: "CS",
          info: "专业云计算管理者",
          background: require("./../assets/image/banner-cs.png"),
          link: "https://lianwei.com.cn/file/2024CS.mp4",
        },
        {
          name: "【联蔚数据】专场",
          code: "DT",
          info: "用数据驱动生意健康增长",
          background: require("./../assets/image/banner-dt.png"),
          link: "https://lianwei.com.cn/file/2024DT.mp4",
        },
        {
          name: "【联蔚电商】专场",
          code: "EoS",
          info: "电商运营整体解决方案",
          background: require("./../assets/image/banner-eos.png"),
          link: "https://lianwei.com.cn/file/2024EOS.mp4",
        },

        {
          name: "【联蔚利歌】专场",
          code: "FTS",
          info: "引领另类投资领域的科技创新",
          background: require("./../assets/image/banner-fts.png"),
          link: "https://lianwei.com.cn/file/2024FTS.mp4",
        },
      ],
      flowList: [
        {
          name: "网申",
          time: "9月1日-11月30日",
          icon: require("./../assets/index/flow1.png"),
        },
        {
          name: "面试",
          time: "9月中旬开始",
          icon: require("./../assets/index/flow2.png"),
        },
        {
          name: "测评",
          time: "9月下旬开始",
          icon: require("./../assets/index/flow2.png"),
        },
        {
          name: "Offer发放",
          time: "9月下旬开始",
          icon: require("./../assets/index/flow4.png"),
        },
      ],
      quizList: [
        {
          id: "link0",
          name: "关于简历投递",
          checked: true,
        },
        {
          id: "link1",
          name: "关于面试",
          checked: false,
        },
        {
          id: "link2",
          name: "关于员工福利",
          checked: false,
        },
      ],
      planList: [
        {
          title: "纵横π",
          type: "技术研发类",
          depart: "联蔚信息-EeS",
          code: "EeS",
          image: require("./../assets/image/image1.png"),
          workList: ["Java开发", "前端开发", "测试"],
          background: require("./../assets/image/bg1.png"),
          description: "春夏更替三载，耕耘与收获兼备，完成职场第一次蜕变",
          plandesc:
            "<p>纵横π计划通过校园招聘、外部选拔、校企合作等渠道，每年定向选拔意愿强烈、能力优秀、潜力无限的应届毕业生，为其提供快速成长计划，帮助他们通过一定时间的培养和塑造成长为联蔚的专业性人才，为其提供有市场竞争力的薪酬待遇及学习成长环境。</p><p>纵横π计划培养生属于定向选拨和培养，会获得各类线上线下通用类培训、岗位专业培训、一对一导师、个人发展计划等一系列培养计划，同时获得更多的项目机会、轮岗机会、转岗机会。</p><p>纵横π人才发展计划将为联蔚数科人才持续发展策略提供坚实的基础。</p>",
          image1: require("./../assets/plan/plan1-1.png"),
          image2: require("./../assets/plan/plan1-2.png"),
          image3: require("./../assets/plan/plan1-3.png"),
          image4: require("./../assets/plan/plan1-4.png"),
          image5: require("./../assets/plan/plan1-5.png"),
        },
        {
          title: "纵横π",
          type: "电商运营/设计人才",
          depart: "联蔚电商",
          code: "EoS",
          image: require("./../assets/image/image4.png"),
          workList: ["电商运营", "视觉设计"],
          background: require("./../assets/image/bg4.png"),
          description: "春夏更替三载，耕耘与收获兼备，完成职场第一次蜕变",
          plandesc:
            "<p>纵横π计划通过校园招聘、外部选拔、校企合作等渠道，每年定向选拔意愿强烈、能力优秀、潜力无限的应届毕业生，为其提供快速成长计划，帮助他们通过一定时间的培养和塑造成长为联蔚的专业性人才，为其提供有市场竞争力的薪酬待遇及学习成长环境。</p><p>纵横π计划培养生属于定向选拨和培养，会获得各类线上线下通用类培训、岗位专业培训、一对一导师、个人发展计划等一系列培养计划，同时获得更多的项目机会、轮岗机会、转岗机会。</p><p>纵横π人才发展计划将为联蔚数科人才持续发展策略提供坚实的基础。</p>",
          image1: require("./../assets/plan/plan2-1.png"),
          image2: require("./../assets/plan/plan2-2.png"),
          image3: require("./../assets/plan/plan2-3.png"),
          image4: require("./../assets/plan/plan2-4.png"),
          image5: require("./../assets/plan/plan2-5.png"),
        },
        {
          title: "D-Star计划",
          type: "Java/前端人才",
          depart: "联蔚信息-DMCS",
          code: "DMCS",
          image: require("./../assets/image/image2.png"),
          workList: ["Java开发", "前端开发"],
          background: require("./../assets/image/bg2.png"),
          description: "培养DMCS未来中流砥柱人才",
          plandesc:
            "<p>主要针对java、前端等技术岗位，基于内部培养体系框架和学习地图，通过半年到一年的培养期，包括导师带教与项目历练，使之平稳通过考核，成为DMCS技术团队的坚实后备力量。</p>",
          image1: require("./../assets/plan/plan3-1.png"),
          image2: require("./../assets/plan/plan3-2.png"),
          image3: require("./../assets/plan/plan3-3.png"),
          image4: require("./../assets/plan/plan3-4.png"),
          image5: require("./../assets/plan/plan3-5.png"),
        },
        {
          title: "云星计划",
          type: "云科技人才",
          depart: "联蔚盘云",
          code: "CS",
          image: require("./../assets/image/image5.png"),
          workList: ["云技术", "云管平台技术"],
          background: require("./../assets/image/bg5.png"),
          description: "上海联蔚盘云科技有限公司，校园招聘三年培养计划",
          plandesc:
            "<p>盘云科技云星计划项目是盘云科技重要的人才发展项目之一，旨在为盘云科技提供源源不断的人才储备，以支持快速业务发展的需要。</p><p>云星计划通过校园招聘、外部选拔、校企合作等项目，每年定向选拔意愿强烈、能力优秀、潜力无限的应届毕业生，为其提供快速成长计划，帮助他们通过三年四阶段的培养和塑造成长为盘云科技的专业性人才，为其提供有市场竞争力的薪酬待遇及学习成长环境。云星计划培养生属于定向选拨和培养，属于盘云科技人才发展计划的重要一环，为盘云科技人才持续发展策略提供坚实的基础。</p>",
          image1: require("./../assets/plan/plan4-1.png"),
          image2: require("./../assets/plan/plan4-2.png"),
          image3: require("./../assets/plan/plan4-3.png"),
          image4: require("./../assets/plan/plan4-4.png"),
          image5: require("./../assets/plan/plan4-5.png"),
        },
        {
          title: "星人养成记",
          type: "咨询顾问人才",
          depart: "联蔚数据",
          code: "DT",
          image: require("./../assets/image/image3.png"),
          workList: ["咨询顾问"],
          background: require("./../assets/image/bg3.png"),
          description: "“星人”计划助力你从职场小白迅速成长为职场专业人士",
          plandesc:
            "<p>数据星球“星人”计划“是联蔚集团下属的联蔚数据公司针对高潜力青年的一项培养计划。这个人才项目承载着培育联蔚优秀数据咨询顾问和中层管理继任者的孵化计划，通过项目负责人带教，导师团授课、专家团赋能、外部专家工作坊、商业实战、客户共创等机制，为创新、多元且具备国际视野的年轻人，打开通往咨询界的大门、迈向专业职场的大舞台</p>",
          image1: require("./../assets/plan/plan5-1.png"),
          image2: require("./../assets/plan/plan5-2.png"),
          image3: require("./../assets/plan/plan5-3.png"),
          image4: require("./../assets/plan/plan5-4.png"),
          image5: require("./../assets/plan/plan5-5.png"),
        },
        {
          title: "匠星计划",
          type: "顾问/开发/运营人才",
          depart: "联蔚利歌",
          code: "FTS",
          image: require("./../assets/image/image6.png"),
          workList: ["顾问", ".NET", "前端", "运营"],
          background: require("./../assets/image/bg6.png"),
          description: "点燃梦想，成就自我",
          plandesc:
            "<p>学生们通过利歌校园招聘的相关面试和笔试环节加入公司后，公司会提供完善的人才培养体系， 旨在培养另类投资领域的科技和行业专家型人才。</p><p>我们有专门针对校园招聘实习生的“匠星计划”,学生们经过实习期+毕业三年的系统性的学习和考核，毕业三年后计划达到专业领域的中高级水平，可具有解决专业领域大多数问题的能力。</p>",
          image1: require("./../assets/plan/plan6-1.png"),
          image2: require("./../assets/plan/plan6-2.png"),
          image3: require("./../assets/plan/plan6-3.png"),
          image4: require("./../assets/plan/plan6-4.png"),
          image5: require("./../assets/plan/plan6-5.png"),
        },
      ],
      visitId: "",
    };
  },
  mounted() {
    if (this.$route.query.active) this.activeName = this.$route.query.active;
    this.marginTop = this.getOffsetTop(document.querySelector(".el-tabs"));
    util.getVisitor("5").then((res) => {
      this.visitId = res;
    }); //page 5空中宣讲会 pv uv
    document.addEventListener("scroll", this.onScroll, false); // 监听滚动事件
    // this.setClock(); //获取服务器时间，并开始计算时间
    this.playVideo = true;
    this.playDepart = this.departList[0];
  },

  beforeDestroy() {
    myApi.updateVisitTime({
      id: this.visitId,
    });
    this.timer && clearInterval(this.timer);
    document.removeEventListener("scroll", this.onScroll, false); //销毁监听
  },
  methods: {
    //绑定滚动事件
    onScroll() {
      let scrolled =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 586、1063分别为第二个和第三个锚点对应的距离
      this.linkFixed = scrolled >= this.marginTop + 164;
      if (scrolled >= 2317) {
        this.checkedQuestion = 2;
      } else if (scrolled < 2317 && scrolled >= 1595) {
        this.checkedQuestion = 1;
      } else {
        this.checkedQuestion = 0;
      }
      this.quizList.forEach((item, index) => {
        item.checked = this.checkedQuestion == index;
      });
    },
    //跳转
    jump(index) {
      let total = this.getOffsetTop(document.querySelector(`#link${index}`)); // 距离浏览器顶端距离
      let distance =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 页面滚动距离
      this.quizList.forEach((item, index1) => {
        item.checked = index == index1;
      });
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
    // 获取距离顶部窗口的距离
    getOffsetTop(el) {
      let marginTop = 0;
      while (el != window.document.body && el != null) {
        marginTop += el.offsetTop;
        el = el.offsetParent;
      }
      return marginTop;
    },
    // 获取点击的视频播放链接
    getVideoLink(index) {
      this.playDepart = this.departList[index];
    },
    // 计算倒计时 ，视频是否能看
    setClock() {
      myApi.getCurrentTime().then((res) => {
        console.log(res);
        this.timer = setInterval(() => {
          // 计算时间节点与当前时间的差值，确认视频是否能观看
          var offset = Math.floor((Date.parse(this.endTime) - res) / 1000);
          if (offset <= 0) {
            clearInterval(this.timer);
            this.playVideo = true;
            this.playDepart = this.departList[0];
          }
        }, 1000);
      });
    },
    // 培养计划弹窗详情
    getplanInfo(index) {
      this.planInfo = this.planList[index];
      this.dialogVisible = true;
    },
    goPosition(depart, target) {
      console.log(target);
      if (target) {
        const routeUrl = this.$router.resolve(`/position?depart=${depart}`); //新窗口打开
        window.open(routeUrl.href, "_blank");
      } else this.$router.push(`/position?depart=${depart}`);
    },
    // 视频点击量
    getVideo() {
      myApi.updateVideoPlayCount({
        videoCode: this.playDepart.code,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.depart {
  width: 1240px;
  margin: 0 auto;
  padding: 32px 0 77px;
  .video-box {
    text-align: left;
    p:last-of-type {
      margin: 8px 0 16px;
    }
    .video {
      width: 816px;
      height: 459px;
    }
    .pause-video {
      width: 816px;
      height: 459px;
      background: url(./../assets/image/video-banner.png) no-repeat center/cover;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        z-index: 9;
        left: 0;
        top: 0;
        height: 459px;
        width: 816px;
        background-color: rgba(0, 0, 0, 0.2);
      }
      .tag {
        position: absolute;
        z-index: 10;
        top: 24px;
        right: 24px;
        padding: 6px 16px;
        background-color: $colorPrimary;
        color: #fff;
        line-height: 20px;
        border-radius: 30px;
      }
    }
    .play-video {
      width: 816px;
      height: 459px;
      .tag {
        display: none;
      }
    }
  }
  .depart-item {
    margin-top: 44px;
    width: 392px;
    text-align: left;
    & > p {
      padding: 0 24px;
      height: 48px;
      line-height: 48px;
      border-bottom: #ebeef5 1px solid;
    }
    .item {
      height: 64px;
      margin-top: 8px;
      padding: 0 24px;
      line-height: 20px;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.2);
        .color-333,
        .color-666 {
          color: $colorPrimary;
        }
      }

      .color-primary {
        .color-333,
        .color-666 {
          color: $colorPrimary;
        }
      }
      .el-button:hover {
        background-color: $colorHover;
      }
      /deep/.el-button--mini {
        padding: 6px 12px;
        width: 72px;
        height: 24px;
        border-radius: 2px;
      }
    }
  }
}
.line {
  height: 1px;
  width: 100%;
  position: relative;
  top: 64px;
  background-color: #ebeef5;
}
/deep/.title-tabs.el-tabs--top {
  width: 1260px;
  margin: 0 auto 40px;
  .el-tabs__nav-wrap {
    width: 1240px;
    margin: 0 auto;
  }
  .el-tabs__nav-wrap::after {
    height: 0;
  }
  .el-tabs__active-bar {
    height: 0;
  }
  .el-tabs__item.is-active {
    border-bottom: 2px solid $colorPrimary;
  }
  .el-tabs__item {
    padding: 0;
    margin: 0 28px;
    height: 64px;
    line-height: 64px;
  }
  .el-tabs__item:nth-of-type(2) {
    margin-left: 0;
  }
  .el-tabs__item:last-of-type {
    margin-right: 0;
  }
  .flex-between {
    align-items: flex-start;
  }
  h3,
  h4 {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
    margin-top: 60px;
  }
  h3 {
    width: 1240px;
    margin: 60px auto 0;
  }
  h4 {
    text-align: center;
    margin-top: 0px;
  }
}
.flow {
  display: flex;
  margin: 40px 0 64px 50px;
  .item {
    width: 120px;
    position: relative;
    .color-333 {
      margin: 16px 0 10px;
    }
  }
  & .item:not(:last-of-type) {
    margin-right: 186px;
  }
  & .item:not(:last-of-type)::after {
    content: "";
    position: absolute;
    top: 38px;
    left: 200px;
    height: 19px;
    width: 14px;
    background: url(./../assets/index/next.png);
  }
}
.link-fixed {
  justify-content: flex-start;
  .link-box {
    position: fixed;
    top: 24px;
  }
  .link-content {
    margin-left: 210px;
  }
}
.link-container {
  width: 1240px;
  margin-left: 10px;
  position: relative;
  .link-box {
    margin-top: 56px;
    height: 115px;
    width: 210px;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #dcdfe6;
    .link-item {
      cursor: pointer;
      display: inline-block;
      text-align: left;
      padding-left: 15px;
      height: 24px;
      line-height: 24px;
      margin-bottom: 22px;
      border-left: 2px solid transparent;
      position: relative;
      left: -2px;
    }
    .link-item:last-of-type {
      margin: 0;
    }
    .link-item:hover,
    .link-checked {
      color: $colorPrimary;
      border-left: 2px solid $colorPrimary;
    }
  }

  .content {
    width: 1028px;
    background-color: #fff;
    padding-top: 56px;
    .box {
      background-color: #f7f7f7;
      padding: 40px 40px 20px;
      h4 {
        position: relative;
        padding-bottom: 32px;
        &::after {
          content: "";
          position: absolute;
          top: 56px;
          left: calc(50% - 16px);
          height: 2px;
          width: 32px;
          background-color: $colorPrimary;
        }
      }
      .question {
        padding: 32px 0;
        color: #666;
        text-align: left;
        line-height: 20px;
        a {
          color: $colorPrimary;
          text-decoration: none;
        }
        p {
          padding-left: 30px;
        }
        p:first-of-type {
          line-height: 22px;
          color: #333;
          font-weight: 600;
          margin-bottom: 20px;
          position: relative;
          padding-left: 30px;
          &::before {
            position: absolute;
            content: "Q：";
            left: 0px;
            top: 0;
          }
        }
        p:nth-of-type(2) {
          position: relative;
          padding-left: 30px;
          &::before {
            position: absolute;
            content: "A：";
            left: 0px;
            top: 0;
          }
        }
        p:nth-of-type(3),
        p:nth-of-type(4) {
          margin-top: 20px;
        }
      }
      .question:not(:last-of-type) {
        border-bottom: 1px dashed #979797;
      }
    }
  }
}
.flex-wrap.plan-box {
  justify-content: space-around;
  .plan-item {
    width: 604px;
    height: 240px;
    align-items: flex-start;
    background-color: #f7f7f7;
    font-size: 16px;
    margin: 20px 0;
    cursor: pointer;
    &:hover {
      background: #ffffff;
      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.2);
      .color-999 {
        color: $colorPrimary;
      }
    }
    .right-info {
      width: 212px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    h4 {
      font-size: 30px;
      font-weight: 600;
      line-height: 42px;
      margin: 36px 0 8px;
    }
    .color-666 {
      width: 100%;
      margin: 8px 0 32px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 38px;
        left: 86px;
        height: 4px;
        width: 40px;
        background-color: $colorPrimary;
      }
    }
    .color-999 {
      font-size: 12px;
      margin-top: 24px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 2;
        margin-left: 4px;
        height: 16px;
        width: 16px;
        background: url(./../assets/public/next.png) no-repeat;
      }
    }
  }
}
/deep/.modal-1240 .el-dialog {
  width: 1261px;
  height: calc(100% - 60px);
  overflow-y: scroll;
  margin: 32px auto 28px !important;
  position: relative;
  .el-dialog__header {
    border: none;
    .el-dialog__title {
      display: none;
    }
  }
  .el-dialog__body {
    padding: 0 74px 60px 74px !important;
    & > .el-image {
      margin-bottom: 32px;
    }
  }
  .el-dialog__headerbtn:hover {
    border-color: $colorPrimary;
    .el-dialog__close {
      color: $colorPrimary;
    }
  }
  h1 {
    margin-top: 8px;
    font-size: 30px;
    font-weight: 600;
    color: #333333;
    line-height: 42px;
  }
  .top-banner {
    height: 320px;
    width: 1092px;
    position: relative;
    margin: 24px 0 32px;
    background-size: 100% 100%;
    text-align: left;
    .info {
      position: absolute;
      top: 184px;
      left: 0;
      width: 420px;
      height: 96px;
      padding-left: 28px;
      border-left: 4px solid $colorPrimary;
      background: rgba(255, 255, 255, 0.8);
      p:first-of-type {
        margin: 12px 0 8px;
      }
    }
  }
  .box {
    height: 100%;
    box-sizing: border-box;
    padding: 24px 32px 50px;
    text-align: left;
    .title {
      height: 28px;
      line-height: 28px;
      font-size: 20px;
      font-weight: 600;
      text-align: left;
      color: #333333;
      position: relative;
      padding-left: 12px;
      margin-bottom: 16px;
      border-left: 2px solid $colorPrimary;
    }
    .plan-con {
      text-align: left;
      line-height: 20px;
      :not(p:last-of-type) {
        text-align: left;
        margin-bottom: 24px;
      }
    }
    .work-con {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      span {
        margin: 0 24px 24px 0;
      }
    }
  }
  .flex-between {
    margin-bottom: 32px;
    display: flex;
    align-items: stretch;
    position: relative;
    > div:first-of-type {
      width: 742px;
    }
    > div:last-of-type {
      height: 100%;
      width: 318px;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
}
</style>
